import {
  AdminUserModeColor,
  AdminUserModeLogo,
  AdminUserModeSubtitle,
  AdminUserModeTitle,
  RegularUserModeColors,
  RegularUserModeLogos,
  RegularUserModeSubtitles,
  RegularUserModeTitles,
  RegularUserSkipLimit,
} from './EnableMfaDialogConstants';
import {
  DialogContent,
  PopupUserMode,
  RegularUserMode,
} from './EnableMfaDialogTypes';

export const isAdminUserMode = (
  mode: PopupUserMode
): mode is 'adminUserMode' => {
  return mode === 'adminUserMode';
};

export const isRegularUserMode = (
  mode: PopupUserMode
): mode is RegularUserMode => {
  return typeof mode === 'object' && mode !== null && 'skipCountUsed' in mode;
};

export const makeContentInDialog = (
  userMode: PopupUserMode,
  proceedCallback: () => Promise<void>,
  cancelCallback: () => Promise<void>
): DialogContent => {
  const isRegular = isRegularUserMode(userMode);

  const logo = isRegular
    ? RegularUserModeLogos[userMode.skipCountUsed]
    : AdminUserModeLogo;

  const title = isRegular
    ? RegularUserModeTitles[userMode.skipCountUsed]
    : AdminUserModeTitle;

  const subtitle = isRegular
    ? RegularUserModeSubtitles[userMode.skipCountUsed]
    : AdminUserModeSubtitle;

  const backgroundColor = isRegular
    ? RegularUserModeColors[userMode.skipCountUsed]
    : AdminUserModeColor;

  const hint = isRegular ? 'You’ll be asked to sign in again' : null;

  const okButtonLabel = isRegular
    ? 'Set up 2-step verification'
    : 'Enable in settings';

  const cancelButtonLabel = isRegular
    ? userMode.skipCountUsed < RegularUserSkipLimit - 1
      ? 'Remind me later'
      : 'Dismiss'
    : 'Remind me later';

  return {
    admin: !isRegular,
    logo: logo,
    title: title,
    subtitle: subtitle,
    backgroundColor: backgroundColor,
    additionalHint: hint,
    cancelButtonProps: {
      label: cancelButtonLabel,
      task: cancelCallback,
    },
    okButtonProps: {
      label: okButtonLabel,
      task: proceedCallback,
    },
  };
};

const makeMfaPopupLocalStorageKey = (currentUserId: string): string => {
  return `lastMfaActionDate-${currentUserId}`;
};

const makeMfaPopupLocalStorageValue = (): string => {
  const today = new Date();
  const [todayFormatted] = today.toISOString().split('T');
  return todayFormatted;
};

export const hadLocalMfaPopupForToday = (currentUserId: string): boolean => {
  const localStorageKey = makeMfaPopupLocalStorageKey(currentUserId);
  const localStorageValueExpected = makeMfaPopupLocalStorageValue();
  const lastStorageValueActual = localStorage.getItem(localStorageKey);
  return (
    lastStorageValueActual &&
    lastStorageValueActual === localStorageValueExpected
  );
};

export const confirmLocalMfaPopupForToday = (currentUserId: string): void => {
  const localStorageKey = makeMfaPopupLocalStorageKey(currentUserId);
  const localStorageValue = makeMfaPopupLocalStorageValue();
  localStorage.setItem(localStorageKey, localStorageValue);
};
